"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFunctionSignature = void 0;
var toSignature_js_1 = require("./toSignature.js");
Object.defineProperty(exports, "toFunctionSignature", { enumerable: true, get: function () { return toSignature_js_1.toSignature; } });
//# sourceMappingURL=toFunctionSignature.js.map